import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenisInstance;

function smooth() {

    lenisInstance = new Lenis();

    lenisInstance.on('scroll', (e) => {
        // console.log(e)
    })

    lenisInstance.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => {
        lenisInstance.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0);

}

export { lenisInstance };
export default smooth;

